import { useEffect, useState } from "react";

export const SMALL_SCREEN_BREAKPOINT = 1024;

export const useScreenSize = () => {
  const [isTooSmall, setIsTooSmall] = useState(
    () => window.innerWidth < SMALL_SCREEN_BREAKPOINT,
  );

  useEffect(() => {
    const onResize = () =>
      setIsTooSmall(window.innerWidth < SMALL_SCREEN_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return { isTooSmall };
};
